/** Builds an {az, ru, en} localized-text payload for a Firestore write
 * (currently used by both service-package and flower-catalog descriptions).
 * Only leading/trailing whitespace is stripped -- a multi-line, bulleted
 * description (entered in an AZ/RU/EN `<textarea>` field) must survive with
 * its internal newlines intact, so the customer app's plain `Text` widgets
 * (which already render embedded "\n" as separate lines, no special
 * handling needed) show the same line breaks the admin typed.
 *
 * Kept in its own file, with no Firebase import, so it stays trivially
 * unit-testable -- the page components that use it pull in `../firebase`
 * (real project config, initialized at module load), which a test has no
 * reason to touch just to check a string-trimming rule. */
export function buildLocalizedTextPayload(az, ru, en) {
  return { az: az.trim(), ru: ru.trim(), en: en.trim() };
}
